import { Link } from 'react-router'
import { cn } from '@/lib/cn'
import { formatRelative } from '@/lib/format'
import type { CallOutcome, ConnectorCall } from './api'

const outcomeChip: Record<CallOutcome, { label: string; tone: string }> = {
  ok: { label: 'Worked', tone: 'ok' },
  empty: { label: 'Found nothing', tone: 'warn' },
  refused: { label: 'Refused', tone: 'bad' },
  error: { label: 'Error', tone: 'bad' },
}

/** Calls an AI tool made to the connector, newest first. */
export function CallsTable({ calls, showWho = true }: { calls: ConnectorCall[]; showWho?: boolean }) {
  if (calls.length === 0) return <p className="empty-line">No calls yet.</p>

  return (
    <div className="tw" style={{ border: 0 }}>
      <table className="t" style={{ minWidth: showWho ? 720 : 520 }}>
        <caption className="sr-only">Connector calls</caption>
        <thead>
          <tr>
            <th>When</th>
            {showWho && <th>Who</th>}
            <th>Tool</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          {calls.map((c) => {
            const chip = outcomeChip[c.outcome]
            return (
              <tr key={c.id}>
                <td className="m" style={{ whiteSpace: 'nowrap' }}>
                  <time dateTime={c.at}>{formatRelative(c.at)}</time>
                  <small>{c.app}</small>
                </td>
                {showWho && (
                  <td>
                    {c.workspace ? (
                      <Link
                        to={`/customers/${c.workspace.id}`}
                        style={{ fontWeight: 600, color: 'var(--ink)' }}
                      >
                        {c.workspace.name}
                      </Link>
                    ) : (
                      '—'
                    )}
                    {c.person && <small>{c.person.email}</small>}
                  </td>
                )}
                <td>
                  {c.tool_label}
                  {c.website && <small>{c.website}</small>}
                </td>
                <td>
                  <span className={cn('chip', chip.tone)}>{chip.label}</span>
                  {(c.reason || c.message) && <small>{c.reason ?? c.message}</small>}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
